// extracted by mini-css-extract-plugin
module.exports = {"narrow":"styles--narrow--1yXk7","default":"styles--default--2vooq","wide":"styles--wide--cF-Rn"};